import colors from 'assets/styles/colors';
import { pxToRem } from 'assets/styles/convertors';
import { mediaQueries } from 'assets/styles/mediaQueries';
import UI from 'constants/ui';
import { Breakpoint } from 'hooks/interface/useBreakpoint';
import styled from 'styled-components';

export const PromotionsInfoElement = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${UI.spacing.xl};
  max-width: ${pxToRem(720)};
  width: 100%;
`;

export const PromotionsInfoBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  gap: ${pxToRem(21)};
  margin-bottom: ${UI.spacing.xl};
`;

export const PromotionInfoDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: ${UI.text.md};

  ${mediaQueries(Breakpoint.XS)`
    flex-direction: row;
    justify-content: space-between;
  `}
`;

export const PromotionsInfoDateWrapper = styled.div<{ $color?: string }>`
  display: flex;
  color: ${({ $color }) => $color ?? 'unset'};
  gap: ${UI.spacing.xs};
  font-weight: 400;
  line-height: 150%;
  align-items: center;
`;

export const PromotionsInfoTag = styled.div`
  font-size: ${UI.text.lg};
  font-weight: 400;
  padding: 0 ${pxToRem(8)};
  border-radius: ${UI.radius.sm};
  border: 1px solid white;
  text-transform: capitalize;
  line-height: 150%;

  @media (hover: hover) {
    &:hover {
      background-color: ${colors.gray700};
    }
  }
`;

export const PromotionsInfoDivider = styled.div`
  width: ${pxToRem(1)};
  height: ${pxToRem(12)};
  background-color: ${colors.gray500};
`;

export const PromotionsInfoText = styled.div`
  font-size: ${UI.text.lg};
  margin-top: ${pxToRem(4)};
`;
